export default "__VITE_PUBLIC_ASSET__a68bac09__"